import { ReusablePaymentMethodBackendIdentifier } from './reusable-payment-method/reusable-payment-method-backend-identifier';
import { WalletPaymentMethodBackendIdentifier } from './wallet-payment-method/wallet-payment-method-backend-identifier';

export type PaymentMethodBackendIdentifier = ReusablePaymentMethodBackendIdentifier | WalletPaymentMethodBackendIdentifier;
